import { render, staticRenderFns } from "./ServiceMobile.vue?vue&type=template&id=6b0449c7&scoped=true&"
import script from "./ServiceMobile.vue?vue&type=script&lang=js&"
export * from "./ServiceMobile.vue?vue&type=script&lang=js&"
import style0 from "./ServiceMobile.vue?vue&type=style&index=0&id=6b0449c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0449c7",
  null
  
)

export default component.exports